// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de las fichas que se colocan sobre la alfombra
 * @param {*} scene 
 */
export function cargaAssetsFichasAlfombra(scene) {

  // ficha10
  scene.load.spritesheet(
    "fichaAlfombra1",
    ROUTES.rutaRuletaFichasAlfombra +
      "/fichaAlfombra1OrangeResized-Sheet.png",
    {
      frameWidth: 20,
      frameHeight: 20,
    }
  );

  // ficha20
  scene.load.spritesheet(
    "fichaAlfombra2",
    ROUTES.rutaRuletaFichasAlfombra +
      "/fichaAlfombra2VioletResized-Sheet.png",
    {
      frameWidth: 20,
      frameHeight: 20,
    }
  );

  // ficha50
  scene.load.spritesheet(
    "fichaAlfombra3",
    ROUTES.rutaRuletaFichasAlfombra +
      "/fichaAlfombra3EmeraldResized-Sheet.png",
    {
      frameWidth: 20,
      frameHeight: 20,
    }
  );

  // ficha100
  scene.load.spritesheet(
    "fichaAlfombra4",
    ROUTES.rutaRuletaFichasAlfombra +
      "/fichaAlfombra4RedResized-Sheet.png",
    {
      frameWidth: 20,
      frameHeight: 20,
    }
  );

  // ficha500
  scene.load.spritesheet(
    "fichaAlfombra5",
    ROUTES.rutaRuletaFichasAlfombra +
      "/fichaAlfombra5DoradaResized-Sheet.png",
    {
      frameWidth: 20,
      frameHeight: 20,
    }
  );
  
}